import { Component, Input } from '@angular/core'
import { BreadcrumbModule, RemoteData } from '@ftr/foundation'
import { FooterComponent } from '@ftr/ui-core'
import { HeaderModule } from '~app/core/header/header.module'

@Component({
  selector: 'ftr-app-layout-legacy',
  templateUrl: './app-layout-legacy.component.html',
  styleUrls: ['./app-layout-legacy.component.css'],
  imports: [BreadcrumbModule, HeaderModule, FooterComponent],
})
export class AppLayoutLegacyComponent {
  @Input() logoData: RemoteData<string | undefined> = RemoteData.notAsked()
}
